import React from 'react'
import styles from './styles.module.scss'

function ReviewActionButtonPure({ text, color, handleClick, iconName, className, renderButton }) {
  return (
    <div className={`${styles.reviewButtonWrapper} ${className}`}>
      {renderButton(text, color, iconName, handleClick)}
    </div>
  )
}

export default ReviewActionButtonPure
